import React, { useState } from 'react'
import { Check, Clock } from 'react-feather'
import styled, { css } from 'styled-components'

import Container from '../../components/Container'
import { COLOR_GREEN } from '../../theme'
import { MEDIA_QUERY_DESKTOP } from '../../utils/media-query'

const Component = styled.div`
  padding: 2rem 0;
  border-top: 1px solid rgba(255, 255, 255, .15);

  ${MEDIA_QUERY_DESKTOP} {
    padding: 4rem 0;
  }
`

const Content = styled.div``

const Sections = styled.div`
  align-self: flex-start;
`

const Inner = styled.div`
  margin-top: 2rem;
  display: flex;
  align-items: center;
`

const ImageContainer = styled.div`
  display: none;

  ${MEDIA_QUERY_DESKTOP} {
    display: block;
  }

  margin-left: auto;
  //display: flex;
  //align-items: center;
  //justify-content: center;
  //width: 100%;
`

const Image = styled.img`
  object-fit: cover;
`

const SectionHeader = styled.div`
  font-size: 1.25em;
  font-weight: bold;
  cursor: pointer;
  user-select: none;
  margin-bottom: .5rem;
  color: white;
  opacity: .4;
  display: inline-block;
  line-height: 1.2;

  &:hover {
    opacity: 6;
  }
`

const SectionDescription = styled.div`
  opacity: .5;
  margin-top: .5rem;
`

const SectionIndicators = styled.div`
  position: absolute;
  top: 6px;
  left: 0;
  bottom: 0;
`

const SectionKnob = styled.div`
  position: absolute;
  width: 14px;
  height: 14px;
  top: 0;
  z-index: 2;
  background-color: #3e3e3e;
  transform: rotate(45deg);
`

const SectionLine = styled.div`
  position: absolute;
  top: 0;
  left: 6px;
  width: 2px;
  height: 100%;
  transform: translateY(10px);
  background-color: #3e3e3e;
`

const Section = styled.div`
  padding-bottom: 1rem;
  position: relative;
  font-size: 16px;

  ${props => {
    if (props.$isOpen) {
      return css`
        ${SectionKnob} {
          background-color: white;
        }

        ${SectionLine} {
          background-color: white;
        }

        ${SectionHeader} {
          opacity: 1;
        }
      `
    }
  }}

  ${props => {
    if (props.$isLast) {
      return css`
        ${SectionLine} {
          background: linear-gradient(180deg, #C4C4C4 0%, rgba(196, 196, 196, 0) 100%);
        }
      `
    }
  }}
`

const SectionContent = styled.div`
  margin-left: 2.5rem;
`

const SectionTasks = styled.div``
const SectionTask = styled.div`
  padding: .5em 0;
  font-size: 1em;
  color: rgba(255, 255, 255, .8);

  ${props => {
    if (props.$isDone) {
      return css`
        color: rgba(255, 255, 255, .5);
      `
    }
  }}
`

const Title = styled.h2``

const sections = [{
  id: '1',
  title: 'Chapter 1. Stealth Mode',
  tasks: [{
    isDone: true,
    title: (
      <>
        Void 1.0 development
      </>
    )
  }, {
    isDone: true,
    title: (
      <>
        Smart contract development
      </>
    )
  }, {
    isDone: true,
    title: (
      <>
        Platform design and development
      </>
    )
  }, {
    isDone: true,
    title: (
      <>
        First artist collaborations & limited NFT releases
      </>
    )
  }]
}, {
  id: '2',
  title: 'Chapter 2. Into The Void',
  tasks: [{
    isDone: true,
    title: (
      <>
        VOID 2.0 development (new features: 3d, automation, effects)
      </>
    )
  }, {
    isDone: true,
    title: (
      <>
        Rebranding (new website)
      </>
    )
  }, {
    isDone: false,

    // TODO: add whitelist link
    title: (
      <>
        Triptcip Objects launch
      </>
    )
  }, {
    isDone: false,
    title: (
      <>
        VOID community contests
      </>
    )
  }, {
    isDone: false,
    title: (
      <>
        Creators Platform (buy and sell your VOID creations)
      </>
    )
  }, {
    isDone: false,
    title: (
      <>
        VOID V4.0
      </>
    )
  }, {
    isDone: false,
    title: (
      <>
        Commercial artist collaborations
      </>
    )
  }]
}, {
  id: '3',
  title: 'Chapter 3. The Beyond',
  description: (
    <>
      We've had a lot more ideas to put on this roadmap but chose to keep it realistic. Triptcip is a long-term project for us and we can't wait to see where it takes us. Festivals? Club collaboration with live version of Void? A music label? An art installation? The possibilities are endless. We're also setting up governance to give you the power to influence the next steps.
    </>
  )
}]

const DoneCheckInner = styled.div`
  display: inline-block;
  margin-right: .5rem;
`

const YupDone = styled.div`
  color: ${COLOR_GREEN};
`

const DONE_CHECK_SIZE = 16

const DoneCheck = ({ isDone }) => {
  if (!isDone) {
    return (
      <DoneCheckInner>
        <Clock size={DONE_CHECK_SIZE} />
      </DoneCheckInner>
    )
  }

  return (
    <DoneCheckInner>
      <YupDone>
        <Check size={DONE_CHECK_SIZE} />
      </YupDone>
    </DoneCheckInner>
  )
}

const IMAGE_SCALE = 1.25

const Roadmap = () => {
  const [openSections, setOpenSections] = useState([
    '1', '2'
  ])

  const toggleSection = sectionId => {
    const isOpen = openSections.includes(sectionId)

    const newOpenSections = isOpen
      ? openSections.filter(s => s !== sectionId)
      : [
          ...openSections,
          sectionId
        ]

    setOpenSections(newOpenSections)
  }

  const handleSectionHeaderClick = section => () => {
    toggleSection(section.id)
  }

  return (
    <Component>
      <Container>
        <Content>
          <Title>
            Roadmap
          </Title>
          <Inner>
            <Sections>
              {sections.map((s, i) => {
                const isOpen = openSections.includes(s.id)
                const isLast = i === (sections.length - 1)

                return (
                  <Section
                    key={s.id}
                    $isLast={isLast}
                    $isOpen={isOpen}
                  >
                    <SectionIndicators>
                      <SectionKnob />
                      <SectionLine />
                    </SectionIndicators>
                    <SectionContent>
                      <SectionHeader onClick={handleSectionHeaderClick(s)}>
                        {s.title}
                      </SectionHeader>
                      {isOpen && (
                        <>
                          {s.tasks && (
                            <SectionTasks>
                              {s.tasks.map((t, i) => {
                                return (
                                  <SectionTask
                                    $isDone={t.isDone}
                                    key={i}
                                  >
                                    <DoneCheck isDone={t.isDone} />
                                    {t.title}
                                  </SectionTask>
                                )
                              })}
                            </SectionTasks>
                          )}
                          {s.description && (
                            <SectionDescription>
                              {s.description}
                            </SectionDescription>
                          )}
                        </>
                      )}
                    </SectionContent>
                  </Section>
                )
              })}
            </Sections>
            <ImageContainer>
              <Image
                src='/images/up@2x.png'
                width={442 * IMAGE_SCALE}
                height={443 * IMAGE_SCALE}
                alt='Roadmap'
              />
            </ImageContainer>
          </Inner>
        </Content>
      </Container>
    </Component>
  )
}

export default Roadmap
